<div class="instructions" [ngClass]="{'visible': show}">
  <app-back-btn class="close" (click)="onConfirm(false)"></app-back-btn>
  <div class="instructions-wrap">
    <p class="instructions__text">
      Ensure you’re: <br>
      1. Facing the camera <br>
      2. Centered with boarder spacing
    </p>
    <div>
      <img class="instructions__img" src="assets/img/capt-correct.png" alt="Correct alignment">
      <img class="instructions__img" src="assets/img/capt-wrong.png" alt="Wrong alignment">
    </div>
    <button mat-flat-button class="btn btn--l btn--primary instructions__btn mb-2" (click)="onConfirm(true)">Understood</button>
  </div>
</div>

<!--<app-photo-uploading-guide></app-photo-uploading-guide>-->
